export const bindHotKey = (eventList: { name: string, code: string, callback: () => void }[]) => {
    const _callback = (event: KeyboardEvent) => {
        const code = event.code;
        const eventItem = eventList.find(item => item.code === code);
        eventItem && eventItem.callback();
    };
    document.addEventListener('keydown', _callback);
    return () => document.removeEventListener('keydown', _callback);
};
